const digest = '0e7f73862d5a46969ccba9e7d5660e72667e507ff028175f0a62a9e6667fe44c';
const css = `._marketingTilesCardWrapper_1rrd6_1,._marketingTilesCard_1rrd6_1{min-height:100%}._marketingTilesWelcomeCardWrapper_1rrd6_6,._marketingTilesWelcomeCardWrapper_1rrd6_6>div,._marketingTilesWelcomeCardWrapper_1rrd6_6>div>div{display:flex;flex:1;flex-direction:column;min-height:100%}._marketingTilesWelcomeCardWrapper_1rrd6_6 ._marketingTilesCardWrapper_1rrd6_1{margin-bottom:0}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'marketingTilesCardWrapper': '_marketingTilesCardWrapper_1rrd6_1', 'marketingTilesCard': '_marketingTilesCard_1rrd6_1', 'marketingTilesWelcomeCardWrapper': '_marketingTilesWelcomeCardWrapper_1rrd6_6' };
export const marketingTilesCardWrapper = '_marketingTilesCardWrapper_1rrd6_1';
export const marketingTilesCard = '_marketingTilesCard_1rrd6_1';
export const marketingTilesWelcomeCardWrapper = '_marketingTilesWelcomeCardWrapper_1rrd6_6';
export { css, digest };